// Sparkline.jsx — daily buckets from /admin/activity, drawn inline.
//
// SVG rather than a chart library: it is one series, it has to be legible at
// 320px wide, and a dependency that ships 90KB to draw fourteen points is a bad
// trade for an app someone opens on plant-floor wifi.

export default function Sparkline({ buckets, valueKey = 'events',
                                    alertKey = null, label }) {
  const values = (buckets || []).map((b) => b[valueKey] || 0);
  const alerts = alertKey ? (buckets || []).map((b) => b[alertKey] || 0) : [];
  const max = Math.max(1, ...values);
  const n = values.length;
  if (!n) return null;

  const W = 100, H = 30;
  const x = (i) => (n === 1 ? W / 2 : (i / (n - 1)) * W);
  const y = (v) => H - (v / max) * (H - 3) - 1.5;
  const line = values.map((v, i) => `${i ? 'L' : 'M'}${x(i).toFixed(2)},${y(v).toFixed(2)}`).join(' ');
  const area = `${line} L${W},${H} L0,${H} Z`;
  const last = buckets[n - 1] || {};

  return (
    <div className="col" style={{ gap: 6 }}>
      <svg className="spark" viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none"
           role="img" aria-label={`${label || valueKey}: ${values.join(', ')}`}>
        <path d={area} fill="var(--accent-soft)" />
        <path d={line} fill="none" stroke="var(--accent)" strokeWidth="1.2"
              vectorEffect="non-scaling-stroke" strokeLinejoin="round" />
        {alerts.map((a, i) => (a > 0 ? (
          <circle key={i} cx={x(i)} cy={y(values[i])} r="1.8" fill="var(--danger)"
                  vectorEffect="non-scaling-stroke" />
        ) : null))}
      </svg>
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <span className="mono dim" style={{ fontSize: 9.5 }}>
          {buckets[0]?.date?.slice(5)}
        </span>
        <span className="mono dim" style={{ fontSize: 9.5 }}>
          peak {max} · today {last[valueKey] ?? 0}
        </span>
      </div>
    </div>
  );
}
